import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import LabelsCrmAPI from '../../api/labelsCrm';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getLabels(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  revalidate: async function revalidate({ commit }, { newKey }) {
    try {
      const isExistingKeyValid = await LabelsCrmAPI.validateCacheKey(newKey);
      if (!isExistingKeyValid) {
        const response = await LabelsCrmAPI.refetchAndCommit(newKey);
        commit(types.SET_LABELS_CRM, response.data.payload);
      }
    } catch (error) {
      // Ignore error
    }
  },

  get: async function getLabelsCrm({ commit }) {
    commit(types.SET_LABELS_CRM_UI_FLAG, { isFetching: true });
    try {
      const response = await LabelsCrmAPI.get(true);
      commit(types.SET_LABELS_CRM, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_LABELS_CRM_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createLabelsCrm({ commit }, labelObj) {
    commit(types.SET_LABELS_CRM_UI_FLAG, { isCreating: true });
    try {
      const response = await LabelsCrmAPI.create({ label_crm: labelObj });
      commit(types.ADD_LABEL_CRM, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_LABELS_CRM_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateLabelsCrm({ commit }, { id, ...updateObj }) {
    commit(types.SET_LABELS_CRM_UI_FLAG, { isUpdating: true });
    try {
      const response = await LabelsCrmAPI.update(id, { label_crm: updateObj });
      commit(types.EDIT_LABEL_CRM, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LABELS_CRM_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteLabelsCrm({ commit }, id) {
    commit(types.SET_LABELS_CRM_UI_FLAG, { isDeleting: true });
    try {
      await LabelsCrmAPI.delete(id);
      commit(types.DELETE_LABEL_CRM, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LABELS_CRM_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_LABELS_CRM_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_LABELS_CRM]: MutationHelpers.set,
  [types.ADD_LABEL_CRM]: MutationHelpers.create,
  [types.EDIT_LABEL_CRM]: MutationHelpers.update,
  [types.DELETE_LABEL_CRM]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
